import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { Search } from './components/Search'
import { Select } from 'src/360ui/Select'
import { Item } from '@react-stately/collections'
import Image from 'next/image'
import Link from 'next/link'
import { intl } from 'src/i18n'
import { reverseData } from 'src/pages/Newsletter/helpers'

type MainProps = {
  newsletters: any
  setDataFilter: (data: any) => void
  search: string
  setSearch: (data: any) => void
  dataFilter: any
  yearFilter: any
  setYearFilter: (data: any) => void
  getWidth: number
  resetFilters: () => void
}

export const Main = ({
  newsletters,
  setDataFilter,
  search,
  setSearch,
  dataFilter,
  yearFilter,
  setYearFilter,
  getWidth,
  resetFilters,
}: MainProps) => {
  const [drawData, setDrawData] = useState(dataFilter)

  useEffect(() => {
    setDrawData(reverseData(dataFilter))
  }, [dataFilter])

  const filterByYear = year => {
    if (year === 'All') {
      resetFilters()
      return
    }

    setYearFilter(year)
    const filteredList = []
    newsletters.map(newsletter => {
      if (newsletter.year === year) {
        filteredList.push(newsletter)
      }
    })
    setDataFilter(filteredList)
  }

  const years = [
    { label: 'All', value: 'All' },
    ...newsletters?.map(newsletter => {
      return { label: newsletter.year, value: newsletter.year }
    }),
  ]

  return (
    <div>
      <div className={styles.header}>
        <div className={styles.archiveContainer}>
          <span className={styles.archive}>
            {intl.t('newsletter.main.archive')}
          </span>
          {getWidth < 768 && (
            <Select
              items={years}
              selectedKey={yearFilter || years[0].value}
              onSelectionChange={selected => filterByYear(selected as string)}
              classNameContainer={styles.select}
              pickerClassName={styles.picker}
            >
              {item => <Item key={item.value}>{item.label}</Item>}
            </Select>
          )}
        </div>
        <Search
          search={search}
          setSearch={setSearch}
          newsletters={newsletters}
          setDataFilter={setDataFilter}
          resetFilters={resetFilters}
        />
      </div>
      {drawData.length > 0 ? (
        drawData?.map(newsletter => {
          return (
            <div key={newsletter.id} className={styles.element}>
              {newsletter.months.map(month => {
                return (
                  <>
                    <span
                      className={styles.month}
                    >{`${month.month}, ${newsletter.year}`}</span>
                    <div className={styles.separator} />
                    {month.newsletters.map((newsletterMonth, index) => {
                      return (
                        <div key={index} className={styles.newsletter}>
                          <Link
                            href={`/newsletter/${newsletterMonth?.slug}`}
                            legacyBehavior
                          >
                            <a className={styles.title}>
                              {newsletterMonth.title}
                            </a>
                          </Link>
                          <span className={styles.date}>
                            {newsletterMonth.date}
                          </span>
                        </div>
                      )
                    })}
                  </>
                )
              })}
            </div>
          )
        })
      ) : (
        <div className={styles.noResults}>
          <Image
            src='/assets/icons/icon-no-result.svg'
            width='48'
            height='48'
            alt='no result icon'
          />
          <span className={styles.noResultsText}>
            {intl.t('newsletter.main.noResult')}
          </span>
          <span className={styles.noResultsSubText}>
            {intl.t('newsletter.main.noResultSearch')}
          </span>
        </div>
      )}
    </div>
  )
}
